import { useState } from 'react'

interface HighlightCardProps {
  highlight: {
    id: string
    title: string
    youtube_video_id: string
    thumbnail_url?: string
    published_at?: string
    channel_name?: string
  }
}

export function HighlightCard({ highlight }: HighlightCardProps) {
  const [playing, setPlaying] = useState(false)

  if (playing) {
    return (
      <div className="card overflow-hidden">
        <div className="aspect-video">
          <iframe
            src={`https://www.youtube.com/embed/${highlight.youtube_video_id}?autoplay=1`}
            title={highlight.title}
            className="w-full h-full"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
        <div className="p-3">
          <h3 className="text-sm font-medium text-white line-clamp-2">{highlight.title}</h3>
        </div>
      </div>
    )
  }

  return (
    <button
      onClick={() => setPlaying(true)}
      className="card overflow-hidden text-left group hover:border-accent/30 transition-colors w-full"
    >
      <div className="aspect-video relative bg-pitch-800">
        {highlight.thumbnail_url && (
          <img
            src={highlight.thumbnail_url}
            alt={highlight.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        )}
        <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/20 transition-colors">
          <div className="w-14 h-14 rounded-full bg-accent/90 flex items-center justify-center group-hover:scale-110 transition-transform">
            <svg className="w-7 h-7 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-slate-200 group-hover:text-white line-clamp-2">
          {highlight.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          {highlight.channel_name && (
            <span className="text-xs text-slate-500">{highlight.channel_name}</span>
          )}
          {highlight.published_at && (
            <span className="text-xs text-slate-600">
              {new Date(highlight.published_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            </span>
          )}
        </div>
      </div>
    </button>
  )
}
